exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img.qb-followup-logo {\n  width: 100%;\n  max-width: 230px;\n  height: auto;\n}\nimg.qb-logo {\n  width: 100%;\n  max-width: 230px;\n  height: auto;\n}\nimg.and-logic-logo {\n  width: 100%;\n  max-width: 65px;\n  height: auto;\n  transition: all .3s linear;\n  filter: invert(26%) sepia(89%) saturate(1583%) hue-rotate(95deg) brightness(96%) contrast(106%);\n}\n.and-logic-logo-red {\n  filter: invert(16%) sepia(99%) saturate(7404%) hue-rotate(4deg) brightness(95%) contrast(118%) !important;\n  transform: rotate(35deg);\n  transition: all .3s linear;\n}\n", ""]);

// exports
